module.exports = __webpack_public_path__ + "img/beer_id-12.383f8eb0.png";